import {put} from "redux-saga/effects";
import {updateState, updateProperties, validatePromotionalCode} from "../reducers/signup";
import {login, updateAuth} from "../reducers/auth";

export function* signupCustomer( action ) {
    try {
        const postResponse = yield fetch(process.env.REACT_APP_CUSTOMER_SIGNUP, {
            method: 'POST',
            headers: {
                "Content-Type":'application/json',
                "Accept": 'application/json',
            },
            body: JSON.stringify( action.payload.body )
        })

        const data = yield postResponse.json();
        if (!postResponse.ok) {
            const errorMessage = data.message || "Something went wrong when attempting to signup customer";
            throw Error(errorMessage);
        }

        yield put(updateState({"error": "", "successMessage": "Success"}));
        yield put(updateAuth({
            "role": data["role"],
            "isAuthenticated": true,
            "error": ""
        }));
        yield localStorage.setItem( "isAuthenticated", true);

        yield put(login({
            "role": data["role"],
        } ));
    }
    catch (e) {
        const error = e.toString();
        yield put( updateState({error, "successMessage": ""}) );
        yield put(updateAuth({
            "role": null,
            "isAuthenticated": false,
            "error": ""
        }));
    }

    yield action.payload.setLoading( false );
}

export function* clearSignupErrors( ) {
    yield put(updateState({"error": "", "successMessage": ""}));
}

export function* handleUsernameValidation( action ) {
    try {
        const postResponse = yield fetch(process.env.REACT_APP_CUSTOMER_USERNAME_VALIDATION, {
            method: 'POST',
            headers: {
                "Content-Type":'application/json',
                "Accept": 'application/json',
            },
            body: JSON.stringify( action.payload.body )
        })


        if (!postResponse.ok) {
            const data = yield postResponse.json();
            const errorMessage = data.message || "Something went wrong when attempting to signup customer";
            throw Error(errorMessage);
        }

        yield put(updateState({"usernameError": "", "successMessage": ""}));
        yield action.payload.setStep( action.payload.nextStep );
    }
    catch (e) {
        const usernameError = e.toString();
        yield put( updateState({usernameError, "successMessage": ""}) );
    }
    yield action.payload.loading(false)
}

export function* handleAddressValidation( action ) {
    try {
        const postResponse = yield fetch(process.env.REACT_APP_CUSTOMER_ADDRESS_VALIDATION, {
            method: 'POST',
            headers: {
                "Content-Type":'application/json',
                "Accept": 'application/json',
            },
            body: JSON.stringify( action.payload.body )
        })

        const data = yield postResponse.json();

        if (!postResponse.ok) {
            const errorMessage = data.message || "Something went wrong when attempting to signup customer";
            throw Error(errorMessage);
        }

        yield put(updateState({"addressError": "", "successMessage": ""}));
        yield action.payload.setStep( action.payload.nextStep );
    }
    catch (e) {
        const addressError = e.toString();
        yield put( updateState({addressError, "successMessage": ""}) );
    }
    yield action.payload.loading(false)
}

export function* handleGetPropertyList( action ) {
    try {
        const response = yield fetch(process.env.REACT_APP_PROPERTY_LIST, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = yield response.json();
        if (!response.ok) throw Error(data.message);
        yield put(updateProperties({ properties: data.properties || [] }));
    } catch (e) {
        yield put(updateProperties({ properties: [] }));
    }
    yield action?.payload?.setLoading?.(false);
}

export function* handlePromoCodeValidation( action ) {
    if (process.env.REACT_APP_CUSTOMER_INITIAL_LAUNCH_CODE === action.payload.code) {
        yield put( validatePromotionalCode( {
            "codeValid": true,
            "promotionalCode": action.payload.code
        }))
    }
    else {
        yield put( validatePromotionalCode( {
            "codeValid": false,
            "promotionalCode": action.payload.code
        }))
    }
}
